import React, { useState, useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { CLEAR_NOTIFICATION } from 'store/actions';

const Alert = React.forwardRef((props, ref) => {
  return <MuiAlert elevation={6} variant="filled" {...props} ref={ref} />;
});

const NotificationComponent = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [notificationType, setNotificationType] = useState('success');
  const [notificationMessage, setNotificationMessage] = useState('');

  const notificationData = useSelector((state) => state.notification);

  useEffect(() => {
    if (notificationData && ['error', 'info', 'success', 'warning'].includes(notificationData.type)) {
      setNotificationType(notificationData.type);
      setNotificationMessage(notificationData.message);
      setOpen(true);
      //wait 3 seconds, then close the notification
      setTimeout(() => {
        setOpen(false);
        dispatch({ type: 'CLEAR_NOTIFICATION' });
      }, 3000);
    }
  }, [notificationData]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={notificationType}>
          {notificationMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default NotificationComponent;
